<app-page-container>
    <div class="legal-content">
      <div class="legalHeader">
        <span [innerHtml]="'legalNotice' | translate"></span>
      </div>
      <div class="legalText" [innerHtml]="imprintText">
      </div>
    </div>
</app-page-container>
